module.exports = __webpack_public_path__ + "static/media/alita.52d68b2d.jpg";